import { QueryData, GoalAnalyticsData } from 'modules/iterableGoals/types';
import { ActionTypes } from '../actionTypes';

export const fetchGoalContributionsByMediumRequest = (queryData: QueryData) => ({
  type: ActionTypes.FETCH_CONTRIBUTIONS_BY_MEDIUM_REQUEST,
  queryData,
});

export const fetchGoalContributionsByMediumResponse = (metrics: GoalAnalyticsData) => ({
  type: ActionTypes.FETCH_CONTRIBUTIONS_BY_MEDIUM_RESPONSE,
  payload: metrics,
});

export const fetchGoalContributionsByMediumError = () => ({
  type: ActionTypes.FETCH_CONTRIBUTIONS_BY_MEDIUM_ERROR,
});
